import React from 'react';
import { useTranslation } from 'react-i18next';

import Processos from '../assets/img/servicos/processos.png';
import Suporte from '../assets/img/servicos/suporte.png';
import Estrutura from '../assets/img/servicos/estrutura.png';
import TI from '../assets/img/servicos/ti.png';
import Compromisso from '../assets/img/servicos/compromisso.png';
import MeninoApontando from '../assets/img/servicos/boy-pointing.png';

const Servicos = () => {
    const { t } = useTranslation('services'); // Usando o namespace 'services'

    return (
        <>
            {/* Seção Recrutamento */}
            <section className="recruiting-section">
            <div>
                <h2 className="recruiting-h2">{t('recruiting.title')}</h2>
                <div className="recruiting">
                    <div className="recruiting-description">
                        <p>{t('recruiting.description')}</p>
                    </div>

                    <div className='content'>
                        <ul>
                            <li>{t('recruiting.items.0')}</li>
                            <li>{t('recruiting.items.1')}</li>
                            <li>{t('recruiting.items.2')}</li>
                            <li>{t('recruiting.items.3')}</li>
                            <li>{t('recruiting.items.4')}</li>
                            <li>{t('recruiting.items.5')}</li>
                            <li>{t('recruiting.items.6')}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <img src={Processos} alt={t('alt.cleaning_waiter')} />
            </section>

            {/* Seção Suporte */}
            <section className="support-section">
                <img src={Suporte} alt={t('alt.cleaning_waiter')} />
                <div className="support-container">
                    <h2 className="title">{t('support.title')}</h2>
                    <p className="description">{t('support.description')}</p>
                    <div className="content">
                        <ul>
                            <li>{t('support.items.0')}</li>
                            <li>{t('support.items.1')}</li>
                            <li>{t('support.items.2')}</li>
                            <li>{t('support.items.3')}</li>
                            <li>{t('support.items.4')}</li>
                            <li>{t('support.items.5')}</li>
                        </ul> 
                    </div>
                </div>
            </section>

            {/* Seção Estrategia */}
            <section className="strategy-section">
                <div>
                    <h2 className="title">{t('strategy.title')}</h2>
                    <div className="strategy-container">
                        <div className="description">
                            <p>{t('strategy.description')}</p>
                        </div>

                        <div className="content">
                            <ul>
                                <li>{t('strategy.items.0')}</li>
                                <li>{t('strategy.items.1')}</li>
                                <li>{t('strategy.items.2')}</li>
                                <li>{t('strategy.items.3')}</li>
                                <li>{t('strategy.items.4')}</li>
                                <li>{t('strategy.items.5')}</li>
                            </ul>

                        </div>
                    </div>
                </div>
                <img src={Estrutura} alt={t('alt.cleaning_waiter')} />
            </section>

            {/* Seção Headhunting */}
            <section className="headhunting-section">
                <img src={TI} alt={t('alt.cleaning_waiter')} />
                <div className="headhunting-container">
                    <h2 className="title">{t('headhunting.title')}</h2>
                    <p className="description">{t('headhunting.description')}</p>
                    <div className="content">
                        <ul>
                            <li>{t('headhunting.items.0')}</li>
                            <li>{t('headhunting.items.1')}</li>
                            <li>{t('headhunting.items.2')}</li>
                            <li>{t('headhunting.items.3')}</li>
                            <li>{t('headhunting.items.4')}</li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* Seção Compromise */}
            <section className="compromise-section">
                <div className="compromise-container">
                    <h2 className="title">{t('compromise.title')}</h2>
                    <p className="description">{t('compromise.description')}</p>
                    <div className="content">
                        <ul>
                            <li>{t('compromise.items.0')}</li>
                            <li>{t('compromise.items.1')}</li>
                            <li>{t('compromise.items.2')}</li>
                            <li>{t('compromise.items.3')}</li>
                            <li>{t('compromise.items.4')}</li>
                        </ul>
                    </div>
                </div>
                <img src={Compromisso} alt={t('alt.cleaning_waiter')} />
            </section>

            {/* Section Final */}
            <section className="final-section">
                <div className="container">
                    <h2 className="title">{t('final.title')}</h2>
                    <p className="description">{t('final.description')}</p>
                    <div className="button-about-us" style={{ display: 'flex' }}>
                        <button>
                            <a href="/cadastro" aria-label={t('final.button')}>{t('final.button')}</a>
                            <span>&gt;</span>
                        </button>
                        <img src={MeninoApontando} alt="" />
                    </div>
                </div>
            </section>
        </>
    );
};

export default Servicos;
